import React, {Fragment} from "react";
import DateTimeInput from "./DateTimeInput";
import PropTypes from "prop-types";
import Select from "./Select";
import moment from "moment";
import {fullyear, halfyears, months, quarters} from "../../utils/other";
import TextInput from "./TextInput";

window.moment = moment;

export const periodOptions = (year, from, to, periods) => {
    const options = [
        ...(new Date().getFullYear() === year ? [{type: "yesterday", name: "Tegnap", from: moment().subtract(1, 'day').startOf('day').format("YYYY-MM-DD"), to: moment().subtract(1, 'day').endOf('day').format("YYYY-MM-DD")}] : []),
        {type: "today", name: "Mai nap", from: moment().startOf('day').format("YYYY-MM-DD"), to: moment().endOf('day').format("YYYY-MM-DD")},
        ...(
            new Date().getFullYear() !== year ?
                [{name: "Az nap", from: moment().year(year).startOf('day').format("YYYY-MM-DD"), to: moment().year(year).endOf('day').format("YYYY-MM-DD")}]
                :
                []
        ),
        ...quarters(year),
        ...halfyears(year),
        ...fullyear(year),
        ...months(year),
    ];
    let selected = null;
    from = moment(from, "YYYY-MM-DD").format("YYYY-MM-DD");
    to = moment(to, "YYYY-MM-DD").format("YYYY-MM-DD");
    periods = (periods || options).map((period) => {
        const key = period.from+"-"+period.to;
        if (from+"-"+(to || from) === key) {
            selected = key;
        }
        return {key, ...period};
    });
    if (!periods.find((p) => p.from + "-" + p.to === from + "-" + to)) {
        periods.push({name: "egyéb", from: null, to: null, other: true});
    }/* else {
        periods.push({name: "egyéb", from, to, other: true});
    }*/
    return {
        selected,
        periods
    }
}

export default class PeriodInput extends React.Component {

    static propTypes = {
        ...DateTimeInput.propTypes,
        periods: PropTypes.array,
    }

    render() {
        const style = {};
        if (this.props.label === false) {
            style.display = "none";
        }
        const values = (this.props.value || []);
        let from = values[0];
        let to = values[1];
        const year = parseInt((values[0] || ((new Date()).getFullYear() + "")).substr(0,4));
        let {selected, periods} = periodOptions(year, from, to, this.props.periods);
        let tags;
        const periodChangeType = this.props.periodChangeType || "autoChange"
        const picker = <div className="row">
            <div className="col-md-6">
                <DateTimeInput
                    {...this.props}
                    value={from}
                    isClearable={periodChangeType === "default"}
                    label={false}
                    selectsStart={true}
                    selectsEnd={false}
                    startDate={from}
                    endDate={to}
                    placeholder="Időpontól"
                    saveChanges={(field, from) => {
                        if (this.props.saveChanges) {
                            if (from && to && moment(from, "YYYY-MM-DD").diff(moment(to, "YYYY-MM-DD")) > 0) {
                                to = from;
                            }
                            this.props.saveChanges(this.props.name, [from, to]);
                        }
                    }}
                />
            </div>
            <div className="col-md-6">
                <DateTimeInput
                    {...this.props}
                    value={to}
                    isClearable={periodChangeType === "default"}
                    label={false}
                    selectsStart={false}
                    selectsEnd={true}
                    startDate={from}
                    endDate={to}
                    placeholder="Időpontig"
                    saveChanges={(field, to) => {
                        if (this.props.saveChanges) {
                            if (from && to && moment(to, "YYYY-MM-DD").diff(moment(from, "YYYY-MM-DD")) < 0) {
                                from = to;
                            }
                            this.props.saveChanges(this.props.name, [from, to]);
                        }
                    }}
                />
            </div>
        </div>;

        const select = <Select
            storeType={"local"}
            labelKey={"name"}
            valueKey={"key"}
            value={selected}
            options={periods}
            label={false}
            placeholder="Periódus"
            saveChanges={(field, period) => {
                if (this.props.saveChanges) {
                    this.props.saveChanges(this.props.name, [period.from, period.to]);
                }
            }}
        />;
        const yearInput = this.props.year === true && <TextInput
            type="number"
            label={false}
            placeholder="Év"
            value={values[0] ? parseInt(moment(values[0], "YYYY-MM-DD").format("YYYY")) : null}
            saveChanges={(field, value) => {
                const from = (values[0] ? moment(values[0], "YYYY-MM-DD") : moment((new Date().getFullYear()) + "-01-01", "YYYY-MM-DD")).year(value).format("YYYY-MM-DD");
                const to = (values[1] ? moment(values[1], "YYYY-MM-DD") : moment((new Date().getFullYear()) + "-12-31", "YYYY-MM-DD")).year(value).format("YYYY-MM-DD");
                if (this.props.saveChanges) {
                    this.props.saveChanges(this.props.name, [from, to]);
                }
            }}
        />;
        if (this.props.layout) {
            tags = this.props.layout(select, picker);
        } else if ((this.props.inline || true) === true) {
            tags = <div className="row">
                {!!yearInput && <div className="col-md-2">
                    {yearInput}
                </div>}
                <div className={yearInput ? "col-md-3" : "col-md-6"}>
                    {select}
                </div>
                <div className={yearInput ? "col-md-7" : "col-md-6"}>
                    {picker}
                </div>
            </div>;
        } else {
            tags = <Fragment>
                {yearInput}
                {select}
                {picker}
            </Fragment>;
        }
        return <Fragment>
            <label
                htmlFor={this.props.name}
                className="control-label"
                style={style}
            >
                {this.props.label} {this.props.required && <span className="invalid-feedback">*</span>}
            </label>
            {tags}
        </Fragment>
    }
}